<template>
  <v-select
    :options="options"
    :reduce="option => option.value"
    :value="value"
    @input="setValue"
    :placeholder="$t('selects.projectSelectPlaceholder')"
    :clearable="false"
    :multiple="false"
    :loading="loading"
  />
</template>

<script>
import projectsApi from '@/api/projects'
import { mapSettings } from '@/utils/settings'

export default {
  name: 'RouteEditorProjectSelect',
  props: {
    value: { type: String },
    companyUuid: { type: String },
  },
  data: () => ({
    projects: [],
    loading: true,
  }),
  computed: {
    ...mapSettings(['projectUuids']),
    options() {
      return this.projects?.map(project => ({
        value: project.uuid,
        label: project.name,
      }))
    },
  },
  methods: {
    setValue(value) {
      this.$emit('input', value)
    },
    async getProjects() {
      this.loading = true
      this.projects = await projectsApi.getAll(this.companyUuid)
      this.loading = false
    },
    async setInitialProjectUuid() {
      await this.getProjects()
      if (this.projectUuids.length > 0) {
        this.setValue(this.projectUuids[0])
      } else {
        this.setValue(this.projects.map(project => project.uuid)[0])
      }
    },
  },
  watch: {
    companyUuid: {
      async handler() {
        if (!this.companyUuid) return
        await this.setInitialProjectUuid()
      },
      immediate: true,
    },
  },
  async created() {
    await this.setInitialProjectUuid()
  },
}
</script>
